var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71435 18.75L9.71435 3.91875L15.0087 8.46C15.5235 8.9025 16.2897 8.83 16.7184 8.3C17.1483 7.76875 17.0778 6.98125 16.563 6.53875L9.2772 0.28875C9.22013 0.24 9.15334 0.21625 9.0902 0.18C9.0392 0.15 8.99549 0.11375 8.93963 0.0912496C8.79998 0.0349996 8.65306 0.00125013 8.50491 0.00125013C8.5037 0.00125013 8.50127 -3.71602e-07 8.50005 -3.71549e-07C8.49884 -3.71496e-07 8.49641 0.00125013 8.4952 0.00125013C8.34705 0.00125014 8.20012 0.0349996 8.06048 0.0912496C8.00462 0.11375 7.96091 0.15 7.90991 0.18C7.84676 0.21625 7.77998 0.24 7.72291 0.28875L0.437145 6.53875C0.149358 6.7875 -5.62019e-07 7.1425 -5.46392e-07 7.5C-5.34044e-07 7.7825 0.0922858 8.06625 0.281716 8.3C0.710361 8.83 1.47658 8.9025 1.99144 8.46L7.28576 3.91875L7.28576 18.75C7.28576 19.44 7.82977 20 8.50006 20C9.17035 20 9.71435 19.44 9.71435 18.75",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/up-arrow-icon.b2b114f23c2ecc2ff226fd6d480080da.svg";
export { ForwardRef as ReactComponent };